import { ContextService } from '../../services/context_service';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { ZusatztoolsZertifizierungInfoAlternatSystem } from './ZusatzToolsZertifizierungInfoAlternatSystem';
import { ZusatztoolsZertifizierungOptionen } from './ZusatzToolsZertifizierungOptionen';
import { ZusatztoolsZertifizierungTabellen } from './ZusatzToolsZertifizierungTabellen';
import { ZusatztoolsZertifizierungTestierung } from './ZusatzToolsZertifizierungTestierung';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';

interface ZusatztoolsZertifizierungProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface ZusatztoolsZertifizierungState {
    tabIndex: number;
}

export class ZusatztoolsZertifizierung extends React.Component<ZusatztoolsZertifizierungProps, ZusatztoolsZertifizierungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxZusatztoolsZertifizierung') || 0
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxZusatztoolsZertifizierung', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const disabledAlternativesSystem: boolean = (((this.props.data || {})[IDs.ENT_KONFIGURATION] || [])[0] || {}).alternatives_system_orig !== 1;
        const tabRoutings: any[] = [
            { path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_OPTIONEN },
            { path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_INFO },
            { path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLEN },
            { path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_TESTIERUNG }
        ];

        return (
            <Tabs
                className={'tabs-zusatztools'}
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxZusatztoolsZertifizierung', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab>Zertifizierungsoptionen</Tab>
                    <Tab disabled={disabledAlternativesSystem}>Info Alternatives System</Tab>
                    <Tab disabled={disabledAlternativesSystem}>Tabellen</Tab>
                    <Tab disabled={true}>Testierung</Tab>
                </TabList>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 0 ? 1 : 0
                    }}
                >
                    {getDefaultHelpIcon('pageLZertifizierungOptionen', 'Hilfe zu Zertifizierungoptionen', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <ZusatztoolsZertifizierungOptionen
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 1 ? 1 : 0
                    }}
                >
                    {!disabledAlternativesSystem && <>
                        {getDefaultHelpIcon('pageLZertifizierungAS', 'Hilfe zu Infos Alternatives System', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <ZusatztoolsZertifizierungInfoAlternatSystem
                            data={this.props.data}
                        />
                    </>}
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 2 ? 1 : 0
                    }}
                >
                    {!disabledAlternativesSystem && <>
                        {getDefaultHelpIcon('pageLZertifizierungTabellen', 'Hilfe zu den Zertifizierungs-Tabellen', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <ZusatztoolsZertifizierungTabellen
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                        />
                    </>}
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 3 ? 1 : 0
                    }}
                >
                    {getDefaultHelpIcon('pageLZertifizierungTestierung', 'Hilfe zu Testierung', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <ZusatztoolsZertifizierungTestierung
                        data={this.props.data}
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
